const VERSION_REQUEST_TIMEOUT = 3000

export const getServiceWorkerVersion = worker =>
	new Promise(resolve => {
		if (worker) {
			const channel = new MessageChannel()
			const timeout = setTimeout(() => resolve(null), VERSION_REQUEST_TIMEOUT)
			channel.port1.onmessage = event => {
				clearTimeout(timeout)
				resolve(event.data?.version || null)
			}
			worker.postMessage({ type: 'GET_VERSION' }, [channel.port2])
		} else {
			resolve(null)
		}
	})

export const isNewerThanCurrentVersion = async (worker, currentVersion) => {
	const workerVersion = await getServiceWorkerVersion(worker)
	return !workerVersion || !currentVersion || workerVersion !== currentVersion
}
